import React from 'react';

import { BetaTagTooltip } from '~components/commons/beta/BetaTagTooltip';

import { CloseIcon, HamburgerMenuIcon, PurpleBarryIcon } from '~assets/images';
import { useBarry } from '~contexts/BarryContext';

import styles from './BarryHeader.module.scss';

interface BarryHeaderProps {
	conversationTitle?: string;
	onToggleSideNavigation: () => void;
}

export const BarryHeader = (props: BarryHeaderProps) => {
	const { onToggleSideNavigation } = props;
	const { closeBarry } = useBarry();

	return (
		<div className={styles.barryHeader}>
			<div className={styles.barryHeaderLeft}>
				<button
					className={styles.barryHeaderButton}
					onClick={onToggleSideNavigation}
				>
					<HamburgerMenuIcon style={{ height: '24px', width: '24px' }} />
				</button>
				<PurpleBarryIcon />
				<h1 className={styles.barryHeaderTitle}>Barry</h1>
				<BetaTagTooltip placement="right" />
			</div>
			<button className={styles.barryHeaderButton} onClick={closeBarry}>
				<CloseIcon />
			</button>
		</div>
	);
};
